import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import './generated-page.css';
import './boot.css';

const rootElement = document.getElementById('root');
const application = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (window.location.pathname === '/') {
  hydrateRoot(rootElement, application);
} else {
  createRoot(rootElement).render(application);
}
